package com.flowyride.core.domain.navigation

import com.flowyride.core.domain.model.Route
import com.flowyride.core.domain.speedcamera.SpeedCamera
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * A ride to navigate.
 *
 * @param stopNames departure, stops, arrival: for "Étape atteinte" messages.
 * @param simulated follows the route by itself instead of the GPS (testing, web).
 */
data class NavigationRequest(
    /** Tells two navigations of the same ride apart. */
    val id: Long,
    val name: String,
    val route: Route,
    val stopNames: List<String>,
    val speedCameras: List<SpeedCamera>,
    val simulated: Boolean,
)

/** The navigation in progress, shared by the planner (starts it) and the navigation screen (shows and ends it). */
class ActiveNavigation {
    private val _request = MutableStateFlow<NavigationRequest?>(null)
    val request: StateFlow<NavigationRequest?> = _request.asStateFlow()

    fun start(request: NavigationRequest) {
        _request.value = request
    }

    fun stop() {
        _request.value = null
    }
}
